export default "__VITE_ASSET__BV9kJSPN__"